import { BehaviorCategoryActionTypes } from '../constants/ApiConstants';

const initialState = {
    loading: false,
    behaviorCategoryList: null,
    behaviorCategoryListDetails: null,
    deleted_behaviorCategoryList: null,
    saved_behaviorCategoryList: null,
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case BehaviorCategoryActionTypes.get_behaviorCategoryList.REQUEST:
            return {
                ...state,
                loading: true,
                behaviorCategoryList: null
            };
        case BehaviorCategoryActionTypes.get_behaviorCategoryList.SUCCESS:
            return {
                ...state,
                loading: false,
                behaviorCategoryList: payload
            };
        case BehaviorCategoryActionTypes.get_behaviorCategoryDetails.REQUEST:
            return {
                ...state,
                loading: true,
                behaviorCategoryListDetails: null
            };
        case BehaviorCategoryActionTypes.get_behaviorCategoryDetails.SUCCESS:
            return {
                ...state,
                loading: false,
                behaviorCategoryListDetails: payload
            };
        case BehaviorCategoryActionTypes.post_behaviorCategory.REQUEST:
            return {
                ...state,
                loading: true,
                saved_behaviorCategoryList: null
            };
        case BehaviorCategoryActionTypes.post_behaviorCategory.SUCCESS:
            return {
                ...state,
                loading: false,
                saved_behaviorCategoryList: payload
            };
            case BehaviorCategoryActionTypes.delete_behaviorCategory.REQUEST:
            return {
                ...state,
                loading: true,
                deleted_behaviorCategoryList: null
            };
        case BehaviorCategoryActionTypes.delete_behaviorCategory.SUCCESS:
            return {
                ...state,
                loading: false,
                deleted_behaviorCategoryList: payload
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/behaviourCategory/reducers/behaviourCategoryReducer.js